import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "semanticColor", "paddingBottom", "pxLegacy", "variant", "deprecatedVariant", "condensed"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, getStatus } from "../../contexts/EncoreContext";
import { colorWarning } from "../../deprecationWarnings";
import { isLegacyVariant, legacyPaddingCheck, legacyVariantCheck, legacyVariants } from "./LegacyType";
import { TypeElement, weights } from "./Type";
var TypeComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      semanticColor = _ref.semanticColor,
      paddingBottom = _ref.paddingBottom,
      pxLegacy = _ref.pxLegacy,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'viola' : _ref$variant,
      deprecatedVariant = _ref.deprecatedVariant,
      condensed = _ref.condensed,
      props = _objectWithoutProperties(_ref, _excluded);

  colorWarning({
    color: color
  });
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.type, config);
  var legacyPassed = isLegacyVariant(variant);

  var _variant = legacyVariantCheck(variant, status, deprecatedVariant);

  var _paddingBottom = legacyPaddingCheck(paddingBottom, condensed);

  return /*#__PURE__*/React.createElement(TypeElement, Object.assign({
    variant: _variant,
    semanticColor: semanticColor,
    paddingBottom: _paddingBottom,
    pxLegacy: pxLegacy,
    isLegacyVariant: legacyPassed,
    ref: ref
  }, props));
}); // export components

export var elements = {
  h1: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h1",
      ref: ref
    }, props));
  }),
  h2: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h2",
      ref: ref
    }, props));
  }),
  h3: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h3",
      ref: ref
    }, props));
  }),
  h4: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h4",
      ref: ref
    }, props));
  }),
  h5: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h5",
      ref: ref
    }, props));
  }),
  h6: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h6",
      ref: ref
    }, props));
  }),
  p: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "p",
      ref: ref
    }, props));
  }),
  small: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "small",
      ref: ref
    }, props));
  }),
  li: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "li",
      ref: ref
    }, props));
  }),
  span: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "span",
      ref: ref
    }, props));
  })
};

var typeHelpers = _objectSpread(_objectSpread(_objectSpread({}, elements), legacyVariants), weights);
/**
* **Type** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Type) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-type--standard-headings) | [Encore](https://encore.spotify.net/web/components/type) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=8300:4850) |
*
* null
*
* @example
* () => (
*  <>
*    <Type as="p" variant="ballad">
*      Ballad
*    </Type>
*    <Type as="p" variant="balladBold">
*      Ballad Bold
*    </Type>
*    <Type as="p" variant="viola">
*      Viola
*    </Type>
*    <Type as="p" variant="violaBold">
*      Viola Bold
*    </Type>
*    <Type as="p" variant="mesto">
*      Mesto
*    </Type>
*    <Type as="p" variant="mestoBold">
*      Mesto Bold
*    </Type>
*  </>
*);
*
*/


export var Type = Object.assign(TypeComponent, typeHelpers);
export default Type;